
import Vue from 'vue'
import JcdcBtn from '@/components/jcdc/JcdcBtn.vue'
import JcdcDataTableGroupIcon from '@/components/jcdc/JcdcDataTableGroupIcon.vue'

interface group {
  name: string
  // This any is defined in Vuetify and cannot be changed - MN
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: any[]
}
export default Vue.extend({
  name: 'JcdcDataTableExpandBtn',
  components: { JcdcBtn, JcdcDataTableGroupIcon },
  props: {
    groupedItems: { type: Array as () => group[], default: (): [] => [] },
    initCollapse: { type: Boolean, default: false },
    groupBy: { type: String, default: '' },
    tableId: { type: String, default: '' },
  },
  data() {
    return {
      // Expansion
      expandAll: false,
      expandText: 'Expand',
    }
  },
  watch: {
    groupBy() {
      this.expandClick(this.expandAll)
    },
  },
  mounted() {
    if (this.groupedItems.length > 0) {
      if (this.initCollapse) {
        this.expandGroups(this.initCollapse)
      } else {
        this.expandAll = true
        this.expandText = 'Collapse'
      }
    }
  },
  methods: {
    expandClick(collapsed) {
      this.expandAll = !this.expandAll
      this.$emit('click', this.expandAll)
      if (collapsed) {
        this.expandText = 'Expand'
      } else {
        this.expandText = 'Collapse'
      }
      if (this.groupedItems.length > 0) {
        this.expandGroups(collapsed)
      }
    },
    expandGroups(collapsed) {
      // Grouped
      const groupedItems = this.groupedItems.map((x) => x.name)
      if (collapsed) {
        groupedItems.forEach((k: string) => {
          const elem = document.getElementById(`${this.tableId}${k}`)
          if (elem && elem.className.includes('true')) {
            elem.click()
          }
        })
      } else {
        groupedItems.forEach((k: string) => {
          const elem = document.getElementById(`${this.tableId}${k}`)
          if (elem && elem.className.includes('false')) {
            elem.click()
          }
        })
      }
    },
  },
})
